/**
 * Labstep
 *
 * @module components/Molecule/Placeholder
 * @desc Placeholder for Molecule on Mobile
 */

import { Button } from 'labstep-web/core/Button';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import type React from 'react';
import type { MoleculePlaceholderProps } from './types';

export const MoleculePlaceholder: React.FC<
  MoleculePlaceholderProps
> = ({ onClose }) => (
  <CardEmptyState
    title="The Molecule Editor is only available on Desktop."
    explanation="For the best experience we block access to our molecule editor on mobile devices."
    src="/img/empty-state/warning.svg"
    action={
      <Button primary onClick={onClose}>
        Close
      </Button>
    }
  />
);
